import { type MapPanelState } from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import styles from "../SettingsSection.module.css";
import { Spotlight } from "../Spotlight";

import { AddPath } from "./AddPath";
import { Paths } from "./Paths";

export interface MapPanelSettingsSidebarProps
  extends PanelSettingsSidebarProps {
  field?: "Paths";
}

interface MapPanelSettingsProps extends MapPanelSettingsSidebarProps {
  state: MapPanelState;
}

export function MapPanelSettings({
  field,
  spotlightKey,
  state,
}: MapPanelSettingsProps) {
  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Paths">
        <Paths panelId={state.id} paths={state.data ?? []} />
        <Spotlight
          className={styles.settingContainer}
          spotlightKey={field === "Paths" ? spotlightKey : undefined}
        >
          <AddPath state={state} />
        </Spotlight>
      </SettingsSection>
    </BasePanelSettings>
  );
}
